import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { Icon, Tooltip } from '../../../../atoms';
import { theme } from '../../../../electrons';
import { Validators } from '../../index';
import { getAnnotationByDefinition } from '../../Spreadsheet.utils';
import useStyles from './ColumnHeaderCell.styles';
export const ColumnHeaderCellRenderer = (definition) => {
    return (container) => {
        var _a;
        // @ts-ignore
        let root = container.__root;
        if (!root) {
            root = createRoot(container);
            // @ts-ignore
            container.__root = root;
        }
        const required = ((_a = definition.validators) === null || _a === void 0 ? void 0 : _a.includes(Validators.isRequired)) ||
            !!definition.required;
        root.render(React.createElement(StyledEngineProvider, { injectFirst: true },
            React.createElement(ThemeProvider, { theme: theme },
                React.createElement(ColumnHeaderCell, { label: definition.title || '', tooltip: definition.tooltip || '', annotation: getAnnotationByDefinition(definition), disabled: definition.readOnly, required: required }))));
    };
};
export function ColumnHeaderCell(props) {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.mainContainer },
            React.createElement("div", { className: classes.labelContainer },
                React.createElement("span", null,
                    props.label,
                    props.required && React.createElement("span", { className: classes.requiredIndicator })),
                props.tooltip && (React.createElement(Tooltip, { title: props.tooltip },
                    React.createElement(Icon, { className: classes.tooltipIcon }, "info_outlined")))),
            props.disabled && (React.createElement(Tooltip, { title: "This column is read-only." },
                React.createElement(Icon, { className: classes.tooltipIcon }, "lock_outlined")))),
        React.createElement("div", { className: classes.annotation }, props.annotation)));
}
export default ColumnHeaderCell;
//# sourceMappingURL=ColumnHeaderCell.js.map